var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jwtDecode } from 'jwt-decode';
import { axiosAuthClient as axios } from 'services/network/axiosClient';
import * as types from './types';
import domains from 'global';
import { logError } from 'utils/logs';
var handleTokenError = function (dispatch, verify, auth) { return __awaiter(void 0, void 0, void 0, function () {
    var params, refreshToken, dataRefresh;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams(window.location.search);
                refreshToken = params.get('refresh_token');
                if (!refreshToken) {
                    refreshToken = window.localStorage.getItem('auth_refresh');
                }
                if (!refreshToken) return [3 /*break*/, 2];
                return [4 /*yield*/, axios.post('/auth/refresh_token', { refresh_token: refreshToken })];
            case 1:
                dataRefresh = (_a.sent()).data;
                if (dataRefresh.status === 'OK') {
                    window.sessionStorage.setItem('auth_token', dataRefresh.data.token);
                    window.localStorage.setItem('auth_refresh', dataRefresh.data.refresh_token);
                    dispatch(verify(auth));
                }
                else if (auth) {
                    document.location.assign("".concat(domains.auth, "?redirect=").concat(window.location.href));
                }
                return [3 /*break*/, 3];
            case 2:
                if (auth) {
                    document.location.assign("".concat(domains.auth, "?redirect=").concat(window.location.href));
                }
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
function verifyToken(auth) {
    var _this = this;
    if (auth === void 0) { auth = true; }
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var token, decoded, err_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({ type: types.FETCH_ROLE_REQUEST, payload: undefined });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 10, , 11]);
                    token = window.sessionStorage.getItem('auth_token');
                    if (!!token) return [3 /*break*/, 3];
                    return [4 /*yield*/, handleTokenError(dispatch, verifyToken, auth)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 3:
                    _a.trys.push([3, 7, , 9]);
                    decoded = jwtDecode(token);
                    decoded.iss = Number(decoded.iss);
                    if (!(Date.now() <= decoded.exp * 1000)) return [3 /*break*/, 4];
                    dispatch({
                        type: types.FETCH_ROLE_SUCCEEDED,
                        payload: decoded,
                    });
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, handleTokenError(dispatch, verifyToken, auth)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    err_1 = _a.sent();
                    return [4 /*yield*/, handleTokenError(dispatch, verifyToken, auth)];
                case 8:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 9: return [3 /*break*/, 11];
                case 10:
                    err_2 = _a.sent();
                    logError(err_2);
                    dispatch({ type: types.FETCH_ROLE_FAILED, payload: err_2 });
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
}
export function isUserAuthorized(usersRoles, necessaryRoles) {
    return necessaryRoles.every(function (r) { return usersRoles.includes(r); });
}
export default verifyToken;
